export enum WidgetMode {
     RESERVED = 'RESERVED',
     ACTIVE = 'ACTIVE',
     PRE_BOOKED = 'PRE_BOOKED',
     ECO_SLOTS = 'ECO_SLOTS'
}
